export const Role = {
  currentRole: (role_id, roles) => {
    let defaultValue = "";
    roles.forEach((role) => {
      if (role.role_id === role_id) {
        defaultValue = role.val;
      }
    });

    return defaultValue;
  },
  currentRoleValue: (role_id, roles, roleSchema) => {
    let defaultValue = null;
    roles.forEach((role) => {
      if (role.role_id === role_id) {
        defaultValue = role.val;
      }
    });
    roleSchema.forEach((role) => {
      if (role.role_id === role_id) {
        role.vals.forEach((val) => {
          if (defaultValue === val.val) {
            defaultValue = val.description;
          }
        });
      }
    });
    return defaultValue;
  },
  isLogmanagerPartner: (user) => {
    let isLogmanagerPartner = false;
    user?.role?.forEach((role) => {
      if (role.role_id === "vendors") {
        role.val?.forEach((val) => {
          if (val.vendor_id === 34) {
            isLogmanagerPartner = true;
          }
        });
      }
    });
    return isLogmanagerPartner;
  },
  hasRole: (user, role, expectedVal) => {
    let hasRole = false;
    user?.role?.forEach((r) => {
      if (r.role_id === role) {
        if (Array.isArray(expectedVal)) {
          if (expectedVal.includes(r.val)) {
            hasRole = true;
          }
        } else {
          if (expectedVal == r.val) {
            hasRole = true;
          }
        }
      }
    });
    return hasRole;
  },
};
